import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  LinearProgress,
  Alert,
  CircularProgress
} from '@mui/material';
import { Warning, Refresh, Logout } from '@mui/icons-material';

const TokenExpiryModal = ({ 
  open, 
  onClose, 
  timeLeft, 
  onRefresh, 
  onLogout, 
  isRefreshing = false,
  error = '' 
}) => {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    const percentage = (timeLeft / 300) * 100;
    setProgress(percentage);
  }, [timeLeft]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
    >
      <DialogContent>
        <Box textAlign="center" py={2}>
          <Warning color="warning" sx={{ fontSize: 48, mb: 2 }} />
          
          <Typography variant="h5" gutterBottom color="warning.main">
            Session sur le point d'expirer
          </Typography>
          
          <Typography variant="body1" color="text.secondary" paragraph>
            Votre session expirera dans {formatTime(timeLeft)}. 
            Pour continuer à travailler, veuillez rafraîchir votre session.
          </Typography>

          <Box mt={3} mb={2}>
            <LinearProgress 
              variant="determinate" 
              value={progress} 
              color="warning"
              sx={{ height: 8, borderRadius: 4 }}
            />
          </Box>

          {/* Affichage des erreurs */}
          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}

          <Alert severity="warning" sx={{ mt: 2 }}>
            Après expiration, vous serez déconnecté automatiquement.
          </Alert>
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ justifyContent: 'center', pb: 3, gap: 2 }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={isRefreshing ? <CircularProgress size={20} /> : <Refresh />}
          onClick={onRefresh}
          size="large"
          disabled={isRefreshing}
        >
          {isRefreshing ? 'Rafraîchissement...' : 'Rafraîchir la Session'}
        </Button>
        
        <Button
          variant="outlined"
          color="inherit"
          startIcon={<Logout />}
          onClick={onLogout}
          size="large"
          disabled={isRefreshing}
        >
          Se Déconnecter
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TokenExpiryModal;